export const quoteDeskingTransform = (quoteInfo) => {
    const {
        accountId,
        cashDown,
        financePlan,
        financeOptions,
        id,
        kmPerYearPlan,
        leadId,
        lien,
        paymentFrequency,
        purchaseMethod,
        quoteRevision,
        saleType,
        taxPlan,
        term,
        tradeIn,
        transactionToken,
        vehicle: {
            year,
            make: { name: make },
            model: { name: model },
            odometer,
            stockNumber,
            vehicleId,
            vin,
        },
        vehicleCondition,
    } = quoteInfo

    return {
        vehicle: {
            year,
            make,
            model,
            odometer,
            stockNumber,
            vehicleId,
            vin,
        },
        quoteInfos: {
            accountId,
            cashDown,
            financePlan,
            financeOptions,
            id,
            kmPerYearPlan,
            leadId,
            lien,
            paymentFrequency,
            purchaseMethod,
            quoteRevision,
            saleType,
            taxPlan,
            term,
            tradeIn,
            transactionToken,
            vehicleCondition,
        },
    }
}
